
<template>
  <div style="border: solid 1px #ccc; border-radius: 15px;">
    <v-form ref="documentForm">
      <v-row class="pa-3">
        <v-col class="" cols="12" sm="6" md="6" lg="3">
          <v-text-field rounded outlined dense class="rounder" 
            :label="$tc('name')"
            v-model="new_document.name"
            :rules="required"
            hide-details
          ></v-text-field>
        </v-col>
        <v-col class="" cols="12" sm="6" md="6" lg="3">
          <v-file-input rounded outlined dense class="rounder" 
            :label="$tc('file')"
            v-model="new_document.file"
            :rules="required"
            hide-details
            truncate-length="15"
            show-size 
            prepend-icon=""
  
          ></v-file-input>
        </v-col>
        <v-col class="" cols="12" sm="6" md="6" lg="4">
          <v-combobox rounded outlined dense class="rounder" 
            v-model="new_document.tag_list"
            :items="tags"
            :search-input.sync="search"
            hide-selected
            :label="$t('tags')"
            multiple
            small-chips
            :rules="required_multiple"
            hide-details
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    No results matching "<strong>{{ search }}</strong>". Press <kbd>enter</kbd> to create a new one
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-combobox>
        </v-col>
        <v-col class="" cols="12" sm="6" md="6" lg="2" align="end">
          <v-btn rounded width="130px" color="primary" class="font-weight-bold text-capitalize "
            @click="submitMovement()"
          >
            {{ $t('send') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
import Api from '@/api/index';

export default {
  name: 'DocumentCreate',
  mixins: [ validations ],
  props: {
    model_used: { // project, company
      type: String, 
    },
    company_id: {
      type: [String, Number]
    },
    project_id: {
      type: [String, Number]
    }
  },
  components: {
    //ComponentName: () => import(''),
  },
  data() {
    return {
      tags: [],
      loading_tags: false,
      search: null,

      new_document: {
        name: null,
        file: null,
        tag_list: [],
      }
    }
  },
  methods: {
    getTags() {
      this.loading_tags = true
      Api.CompanyTags.index(1).then(r=>r.data).then(d=> {
        this.tags = [...d]
      }).catch(err=>{
        console.log({err});
      }).finally(()=>{
        this.loading_tags = false
      })
    },
    submitMovement() {
      if (this.$refs.documentForm.validate()){
        this.loading = true
        // let {value, due_date, ...mov} = this.new_document
        // due_date = this.$dayjs(due_date).add(12, 'hour').format()
        // value = Number(value.replace(/,/g, ''))*100
        if (this.company_id){
          this.new_document.company_id = this.company_id
        }
        if (this.project_id){
          this.new_document.project_id = this.project_id
        }
        Api.Document.createFormData(this.new_document).then(r=>r.data).then(d=> {
          console.log({d});
          this.$refs.documentForm.reset()
          this.$emit('done')
          this.getTags()
        }).catch(err=> {
          console.log({err});
        }).finally(()=> {
          this.loading = false
        })
      }
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    this.getTags();
  },
}
</script>

<style scoped>

</style>